

export default class UserModel  {
  id: number;
  name: string;
  email: string;
  password: string;

  // public constructor(id: number, name: string, email:string, password:string ) {
  //   this.id = id;
  //   this.name = name;
  //   this.email = email;
  //   this.password = password;
  // }

  
  // public ToString() {
  //   return `${this.name}`;
  // }
}



// WEBPACK FOOTER //
// ./scripts/views/a-model/user-model.ts